import { render, staticRenderFns } from "./SelectedParticipantTabs.vue?vue&type=template&id=5b2b31c8&"
var script = {}


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports